module.exports = __webpack_public_path__ + "img/make-collection.2853820c.svg";